import React from 'react';
import { Divider } from 'semantic-ui-react';
import propTypes from 'prop-types';
import CreateProvider from './store/CreateProvider';
import ContentWrapper from './../../../../template/Layout/ContentWrapper';
import ClientesList from '../../../../../services/storageClient.js';

// ? Actions imports
import ReportType from './app/ReportType';
import ReportConfig from './app/ReportConfig';
import ShareTo from './app/ShareTo/';
import Scheduling from './app/Scheduling';
import ReportPreview from './app/ReportPreview';
import SaveReport from './app/SaveReport';
import { Row } from 'reactstrap';

function CreateAndEdit(props) {
  const clientSave = new ClientesList();
  const clientesSelect = clientSave.getAuthentication('client')

  // console.log('props-->', props);
  return (
    <CreateProvider>
      <ContentWrapper>
        {
          props.action === 'create' ?
            <div className="content-heading">
              <em className="fas fa-1x mr-2 fas fa-pencil-alt" />
                Create New Report
            </div> : ''
        }
        <div >
          <Row>
            <ReportType />
            <SaveReport action={props.action} reportId={props.reportId} onEvent={props.onEvent} clients={clientesSelect}/>
          </Row>
        </div>
        <Divider section />
        <ReportConfig />
        <ShareTo />
        <br></br>
        <Scheduling />
        <Divider section />
        <div class="float-right mb-5">
          <p className='text-muted'>Note: The total results of the report is limited to 1000 records.</p>
        </div>
        <ReportPreview action={props.action} reportId={props.reportId} />
      </ContentWrapper>
    </CreateProvider>
  );
}

CreateAndEdit.propTypes = {
  action: propTypes.string,
  reportId: propTypes.number,
};
CreateAndEdit.defaultProps = {
  action: 'create',
  reportId: 0
};

export default CreateAndEdit;